import {
  buildPermissionMatcher,
  PermissionMatcher,
} from "@utils/permissions/buildPermissionMatcher";

export const getAdaptivePermissionMatcher = (
  v2Permission: string,
  legacyPermission: string | undefined,
  useSystemModulesAuth: boolean
): PermissionMatcher => {
  const permission = useSystemModulesAuth
    ? v2Permission
    : legacyPermission || v2Permission;
  return buildPermissionMatcher(permission);
};

export const getRouteGuardRules = (
  v2Permission: string,
  legacyPermission: string | undefined,
  useSystemModulesAuth: boolean
): PermissionMatcher | undefined => {
  if (!useSystemModulesAuth) {
    return legacyPermission
      ? buildPermissionMatcher(legacyPermission)
      : undefined;
  }

  return buildPermissionMatcher(v2Permission);
};
